<template>
  <div class="container">

    <div class="row mt-5 ">
      <div class="col-md-12 col-lg-6 col-xl-6">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb bg-white" style="font-size: 15px">
            <li class="breadcrumb-item"><a v-bind:href="'/'+cliente">Inicio</a></li>
            <li class="breadcrumb-item"><a v-bind:href="'/'+ cliente +'/'+Categoria.slug">{{Categoria.categoria}}</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Actual</li>
          </ol>
        </nav>
      </div>
      <div class="col-md-12  col-lg-6 ">
        <buscador class="justify-content-lg-end align-content-center comun-contenedor-buscador"></buscador>
      </div>
    </div>
    <!---->

    <div class="card">
      <div class="card-header">
        <h5 style="color: #000000;font-weight: 500" class="pt-3 text-center">
          {{ contenido.titulo }}
        </h5>
      </div>
      <div class="card-body px-0 px-md-5 text-justify" style="background-color: transparent;">
        <div class="" style="color: #000000; font-weight: 400; font-size: 16px" v-html="contenido.contenido"></div>
        <div class="card my-5 ">
          <div class="articulo-util" v-if="articuloUtil">
            <div class="card-header text-center border-bottom-0 border-left-0 border-light-0  pb-0 pt-4">
              ¿Fue útil este artículo?
            </div>
            <div class="card-body text-center">
              <button type="button" class="btn btn-outline-secondary" style="padding: 21px 44px"
                      @click="contenidoUtil(contenido,'si')">SI
              </button>
              <button type="button" class="btn btn-outline-secondary" style="padding: 21px 38px"
                      @click="contenidoUtil(contenido,'no')">NO
              </button>
            </div>
          </div>
          <div class="articulo-util" v-else>
            <div class="card-header text-center border-bottom-0 border-left-0 border-light-0  pb-0 pt-4">
              <h3>Gracias por su opinión!</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import buscador from '../share/buscador'

  import listApiUrl from '../../compartida/listApiUrl';

  export default {
    name: "cuerpo",
    data() {
      return {
        contenido: '',
        cliente: '',
        Categoria: '',
        articuloUtil: true
      }
    },
    components: {
      buscador
    },
    created() {
      this.cliente = this.$route.params.cliente;
      let categoria = this.$route.params.categoria;
      let contenido = this.$route.params.contenido;

      axios.get(`${listApiUrl.BASE_URL_PRODUCCION + listApiUrl.API_URL_PUBLICO + listApiUrl.API_URL_PUBLICO_CONTENIDO + '/'}${this.cliente}/${categoria}/${contenido}`)
        .then(response => {
          this.contenido = response.data.data[0];
          this.Categoria = response.data.data[0].categoria;

          let utilArticulo = localStorage.getItem('articulo_util_' + this.contenido.id);
          if (utilArticulo != undefined || utilArticulo != '' || utilArticulo != null && utilArticulo)
            this.articuloUtil = true;

          EventBus.$emit('nombreEmpresa', response.data.data[0].categoria.cliente.nombre);
        }).catch(e => {
        console.log(e);
      });

    },
    methods: {
      contenidoUtil: function (contenido, tipo_util) {
        console.log(contenido, tipo_util);
        console.log(listApiUrl);
        this.articulo_util(contenido);
        // var f='publico/contenido/util/{contenido_id}/tipo-util/{tipo_util}';
        axios.get(`${listApiUrl.BASE_URL_PRODUCCION + listApiUrl.API_URL_PUBLICO + listApiUrl.API_URL_PUBLICO_CONTENIDO }/util/${contenido}/tipo-util/${tipo_util}`)
          .then(response => {
            if (response.status) {
            }
          }).catch(e => {
          console.log(e);
        });
      },
      articulo_util: function (contenido) {
        localStorage.setItem('articulo_util_' + contenido.id, true);
        this.articuloUtil = false;
      }
    }
  }
</script>

<style scoped lang="scss">
  .card, .card-body, .car-footer, .card-header {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.0), 0 0 0 0 rgba(0, 0, 0, .0), 0 0 0 0 rgba(0, 0, 0, .0);
    -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.0), 0 0 0 0 rgba(0, 0, 0, .0), 0 0 0 0 rgba(0, 0, 0, .0);
  }

</style>




// WEBPACK FOOTER //
// src/components/publico/fragmentoContenido/cuerpo.vue